import { render } from "./button.vue?vue&type=template&id=7beea14f&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=7beea14f&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7beea14f"]])

export default __exports__